export default function HavasLogoSm() {
  return (
    <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M11.4214 4.35261L2.2971 8.62018V0H0V14.8053H2.2971V11.024L11.4214 6.75644L11.4214 14.8053H13.7185V0H11.4214L11.4214 4.35261Z" fill="#E60000"/>
    </svg>
  );
}
